import { useCallback, useEffect, useRef } from 'react';
export function useMenuToggle({ isOpen, onToggle, onOpen, }) {
    const prevIsOpenRef = useRef(isOpen);
    useEffect(() => {
        if (isOpen && !prevIsOpenRef.current) {
            onOpen?.();
        }
        prevIsOpenRef.current = isOpen;
    }, [isOpen, onOpen]);
    const handleToggle = useCallback((open) => {
        if (open && !prevIsOpenRef.current && isOpen === undefined) {
            onOpen?.();
        }
        prevIsOpenRef.current = open;
        onToggle?.(open);
    }, [isOpen, onOpen, onToggle]);
    return { handleToggle };
}
//# sourceMappingURL=useMenuToggle.js.map